// Idempotent DOM bindings for the design shell: toolbar actions, left tabs, commerce CTA, product info rail.

import { store } from '../../core/store.js'
import { undo, redo } from './sds/history.js'
import * as canvas from './sds/canvas.js'
import imageProcessor from '../../services/image-processor.js'
import { handleShareBuyClick } from './share-buy/index.js'
import { populateDesignProducts } from './products-panel.js'

/**
 * Bind toolbar button actions (undo, redo, add-image, add-text, etc.)
 */
export function bindToolbar() {
  const toolbar = document.getElementById('designToolbar')
  if (!toolbar || toolbar.dataset.bound) return
  toolbar.dataset.bound = '1'

  toolbar.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-action]')
    if (!btn) return
    const action = btn.dataset.action
    switch (action) {
      case 'undo': undo(); break
      case 'redo': redo(); break
      case 'add-text': canvas.addText(); break
      case 'delete': {
        const sdk = store.getState('design.sdkInstance')
        if (sdk?.sarto?.deleteActiveObject) sdk.sarto.deleteActiveObject()
        break
      }
      case 'grid': imageProcessor.toggleGrid(); break
      case 'opacity': imageProcessor.showOpacitySlider(); break
      case 'add-image': {
        // Trigger file input for image upload
        const input = document.createElement('input')
        input.type = 'file'
        input.accept = 'image/*'
        input.onchange = (ev) => {
          const file = ev.target.files?.[0]
          if (file) canvas.addSDKImage(file)
        }
        input.click()
        break
      }
      case 'zoom-in': {
        const sdk = store.getState('design.sdkInstance')
        if (sdk?.sarto?.zoomIn) sdk.sarto.zoomIn()
        break
      }
      case 'zoom-out': {
        const sdk = store.getState('design.sdkInstance')
        if (sdk?.sarto?.zoomOut) sdk.sarto.zoomOut()
        break
      }
    }
  })
}

// The former shell design note is archived at
// The implementation is the source of truth for the current bindings.


/**
 * Left panel tab switching (Arts | Products). Idempotent.
 */
export function bindLeftTabs() {
  const tabs = document.querySelectorAll('#sds-container .design-tab')
  if (!tabs.length || tabs[0].dataset.bound) return
  tabs.forEach((tab) => {
    tab.dataset.bound = '1'
    tab.addEventListener('click', () => {
      const target = tab.dataset.designTab
      tabs.forEach((t) => t.classList.toggle('active', t === tab))
      document.querySelectorAll('#sds-container .design-panel').forEach((p) => {
        p.classList.toggle('active', p.dataset.designPanel === target)
      })
      if (target === 'products') populateDesignProducts()
    })
  })
}

/**
 * Right-rail commerce CTA (Share & Buy). Idempotent.
 */
export function bindCommerceButtons() {
  const btn = document.getElementById('btnShareBuy')
  if (!btn || btn.dataset.bound) return
  btn.dataset.bound = '1'
  btn.addEventListener('click', (e) => handleShareBuyClick(e))
}

/**
 * Right-rail product name + price. PRODUCT_SELECT carries name/price; the
 * boot-preload path only has an id, so fall back to sdk.getProductInfo().
 */
export function updateProductInfoPanel() {
  const nameEl = document.getElementById('productNamePreview')
  if (!nameEl) return
  const current = store.getState('design.currentProduct')
  const sdkProduct = store.getState('design.sdkInstance')?.product
  // sdk.product is a sync property; sdk.getProductInfo() fires an id-less
  // gateway fetch (400) — never call it here.
  const name = current?.name || sdkProduct?.english_name || sdkProduct?.name
  if (name) nameEl.textContent = name
  const priceEl = document.getElementById('productPricePreview')
  const price = current?.price ?? sdkProduct?.currentPrice
  if (priceEl && price) priceEl.textContent = `$${Number(price).toFixed(2)}`
}
